export const reading = [
  {
    id: "purpose",
    type: "dropdown",
    choices: [
      "Summarize the text",
      "Extract key points and arguments",
      "Identify the main purpose or theme",
      "Answer specific questions about the text",
      "Analyze the tone and style",
      "Translate the text",
      "Rewrite the text in a different style",
    ],
  },
  {
    id: "textInput",
    type: "textarea",
    placeholder: "Paste the text you want the AI to process",
  },
  {
    id: "questions",
    type: "textarea",
    placeholder:
      "Enter specific questions you want the AI to answer based on the text",
    conditional: (opts) =>
      opts.task === "Answer specific questions about the text",
  },
  {
    id: "summaryLength",
    type: "dropdown",
    choices: ["Short summary", "Detailed summary", "Bullet points"],
    conditional: (opts) => opts.task === "Summarize the text",
  },
  {
    id: "outputFormat",
    type: "dropdown",
    choices: ["Paragraph", "Bullet points", "Table", "JSON"],
  },
];
